<template>
  <aside class="side-bar" v-cloak :class='{mobile: mobileView}'>
    <div class="filters-container">
      <div class='selectDrop' v-if='multiAccount && !mobileView'>
        <div class='selectDropInput' @click="multiAccountSelectToggle()">
          <input v-if='multiAccountSelect' :value='checkedAccountNum+" Selected"' disabled>
          <input v-else type='text' :value='"Select Accounts ("+checkedAccountNum+" Selected)"' disabled>
        </div>

        <div class='selectDropDropdown' v-if='multiAccountSelect'>
          <div class="checkwrap all"  @click='toggleAll()'>
            <div class="checkbox">
              <input type='checkbox' :checked='filteredLskins.length === options.length'>
              <i class="zmdi zmdi-square-o checkbox"></i>
              <i class="zmdi zmdi-check-square checkbox"></i>
            </div>
            <label class="sub">All</label>
          </div>

          <div class="checkwrap" v-for='option in options'>
            <div class="checkbox">
              <input type='checkbox' v-model='filteredLskins' :id='option' :value='option' class="accountSelect">
              <i class="zmdi zmdi-square-o checkbox"></i>
              <i class="zmdi zmdi-check-square checkbox"></i>
            </div>
            <label class="sub" :for="option">{{ accounts[option].refname }}</label>
          </div>
        </div>

        <div class="selectDropShadow"  v-if='multiAccountSelect'  @click='closeMultiSelect()'></div>
      </div>
      <singleSelect :optionalClass="false">
        <select v-model='filterVal' @change='updateFilter(filterVal)' slot="singleSelectMain">
          <option>Following & New</option>
          <option v-if='liveButton'>All Convos</option>
          <option selected default>Unaddressed</option>
          <option>Following</option>
          <option v-if='liveButton' :value='[group.PhonecodeClass.class_name, group]' v-for='group in filteredPhonecodeGroups'>{{ group.PhonecodeClass.class_name }} & New</option>
        </select>
      </singleSelect>

      <div class="inputWrapper searchDrop searchbar">
        <div class="searchDropIcons">
          <i class="zmdi zmdi-search"></i>
          <i class="zmdi zmdi-close" v-if='showClearSearch' @click='clearSearch()'></i>
        </div>

        <inputTemplate :hasIcon="false" :hasButton="false" :hasLabel="false">
          <input type="text" name="searchbar" v-model="searchbarVal" @keyup.enter='goSearch' placeholder="Search phone number" slot="inputEl" class="sideBarPhoneSearch">
        </inputTemplate>
      </div>

      <div class='selectDrop mobile' @click="multiAccountSelectToggle()" v-if='multiAccount && mobileView'>
        <div class='selectDropInput'>
            <input v-if='multiAccountSelect' :value='checkedAccountNum+" Selected"' disabled>
            <input v-else type='text' :value='"Select Accounts ("+checkedAccountNum+" Selected)"' disabled>
        </div>
       </div>
    </div>

    <div class="convo-list-container">
        <sideBarItem v-for="item in inboxData" @convoClicked="selectConvo(item)" :conversation="item" :key="item.conversationid">
        </sideBarItem>
        <loadingGif v-if="loadingInbox" optionalClass="loading-container-inbox">
        </loadingGif>
    </div>

    <div class="pageButtons" @click="loadMore()">
      <label class='sub' v-if="!loadingMore">SHOW MORE</label>
      <loadingGif v-else>
      </loadingGif>
    </div>

    <!--- account selection popup --->
    <article class='popupBG' v-if='multiAccount && mobileView && multiAccountSelect'>
      <div class='popup multiAccount'>
        <div class='title'>
          <div class='popupTitleWrap'>
            <h2>Select Accounts</h2>
            <label>({{checkedAccountNum}} Selected)</label>
          </div>

          <div class='close'  @click='closeMultiSelect()'></div>
        </div>

        <div class='content'>
          <div class="checkwrap all"  @click='toggleAll()'>
            <div class="checkbox">
              <input type='checkbox' id="all" :checked='filteredLskins.length === options.length'>
              <i class="zmdi zmdi-square-o checkbox"></i>
              <i class="zmdi zmdi-check-square checkbox"></i>
            </div>
            <label class="sub">All</label>
          </div>

          <div class="checkwrap" v-for='option in options'>
            <div class="checkbox">
              <input type='checkbox' v-model='filteredLskins' :id='option' :value='option' class="accountSelect">
              <i class="zmdi zmdi-square-o checkbox"></i>
              <i class="zmdi zmdi-check-square checkbox"></i>
            </div>
            <label class="sub" :for="option">{{ accounts[option].refname }}</label>
          </div>
        </div>
      </div>

      <div class='popupCloseWrap' @click='closeMultiSelect()'></div>
    </article>
  </aside>
</template>

<script>
import $ from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'
import { mapState, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import crypto from 'crypto';
import singleSelect from '@/components/singleSelect.vue'
import inputTemplate from '@/components/inputTemplate.vue'
import sideBarItem from '@/components/sidebarItem.vue'
import loadingGif from '@/components/loadingGif.vue'
require('../assets/css/sideBar.css')

export default {
  name: 'sidebar',
  props: ['currentView', 'waveformsArray', 'mobileView', 'showHideSide'],
  components: {
    Multiselect,
    singleSelect,
    inputTemplate,
    sideBarItem,
    loadingGif
  },
  data: function () {
    return {
      currentConvo: this.$store.state.inboxData[0],
      convoData: this.$store.state.inboxData,
      searchbarVal: '',
      searchStr: '',
      queryData: '',
      filterVal: this.$store.state.selectedFilter,
      loadMoreStart: '',
      multiAccountSelect: false,
      selectedAccount: 'All',
      ddOpen: false,
      showMultiMobile: false,
      showClearSearch: false,
      oldestConversation: '',
      vinintegrationalert: false,
      isDS: false,
      isElead: false
    }
  },
  mounted: function () {
    this.loadConversations();

    this.$root.$on('campaignConvoLoad', async (payload) => {
      const {
        lskin,
        ani,
        campaignInfo
      } = payload;

      await this.campaignPopulateHandler(lskin, ani, campaignInfo);
    })

    this.$root.$on('markReadMessage', (textObj) => {
      this.markRead(this.lskins, this.user.leuserid, textObj.ani, textObj._id)
    })

    this.$root.$on('scrollDisplay', () => {
      setTimeout(this.scrollMessages, 100)
    })

    this.$root.$on('initiateDeepLinkHandler', () => {
      if (this.deepLinkConversationId && !this.deepLinkExecuted) {
        this.deepLinkHandler();
        this.$router.replace({'query': null});
      }
    })

    this.$root.$on('socketConnection', () => {

      this.$store.commit('turnSocketOn');

      // Only load conversations on establishing new connections
      if (this.socketOn > 1) {
        this.loadConversationsSocketReconnect();
      }
    });
  },
  computed: {
    ...mapState({
      apptOpsHcos: state => state.apptOpsHcos,
      bookedHcos: state => state.bookedHcos,
      phonedamentalsHcats: state => state.phonedamentalsHcats,
      negativeHcos: state => state.negativeHcos,
      inboxData: state => state.inboxData,
      account: state => state.account,
      agents: state => state.agents,
      currentThread: state => state.currentThread,
      conversationOwner: state => state.conversationOwner,
      connectedOBHcos: state => state.connectedOBHcos,
      connectedHcos: state => state.connectedHcos,
      loadingInbox: state => state.loadingInbox,
      loadingMore: state => state.loadingMore,
      user: state => state.user,
      query45: state => state.query45,
      currentConvoViewId: state => state.currentConvoViewId,
      liveButton: state => state.liveButton,
      dnis: state => state.dnis,
      currentAccount: state => state.account.lskinid,
      selectedFilter: state => state.selectedFilter,
      accounts: state => state.accounts,
      deepLinkConversationId: state => state.deepLinkConversationId,
      deepLinkExecuted: state => state.deepLinkExecuted,
      socketOn: state => state.socketOn,
      multiFlag: state => state.multiFlag,
      phonecodeGroups: state => state.phonecodeGroups,
      selectedPhonecodeGroup: state => state.selectedPhonecodeGroup,
      masterAccount: state => state.callCenterMasterLskin,
      secret: state => state.secret,
      linesToFilter: state => state.linesToFilter,
      vinDealercodes: state => state.vinDealercodes,
      dsDealercodes: state => state.dsDealercodes,
      eleadDealercodes: state => state.eleadDealercodes,
      nexhealthLskins: state => state.nexhealthLskins,
      user: state => state.user,
      currentHproduct: state => state.currentHproduct,
      aniToCampaignMap: state => state.aniToCampaignMap
    }),
    ...mapGetters([
      'lskins',
      'multiAccount',
      'filterLines'
    ]),
    filteredLskins: {
      get () {
        return this.$store.getters.filteredLskins
      },
      set (lskinArray) {
        this.$store.commit({
          type: 'updateFilteredLskins',
          lskinArray: lskinArray
        })
      }
    },
    filteredPhonecodeGroups: function () {
      let phonecodeGroupsAdded = {};
      let filteredGroups = [];
      let phonecodeGroup = this.phonecodeGroups[this.masterAccount];

      if (phonecodeGroup && phonecodeGroup.length) {
        for (let phonecodeClass of phonecodeGroup) {
          if (!phonecodeGroupsAdded[phonecodeClass.frn_phonecode_classid]) {
            filteredGroups.push(phonecodeClass);
          } else {
            phonecodeGroupsAdded[phonecodeClass.frn_phonecode_classid] = true;
          }
        }
      }

      return filteredGroups.sort( (a,b) => {
        return a.PhonecodeClass.class_name.toLowerCase().localeCompare(b.PhonecodeClass.class_name.toLowerCase());
      });
    },
    checkedAccountNum: function () {
      return this.$store.getters.filteredLskins.length
    },
    options: function () {
      return this.$store.getters.lskins
    },
    sortedConvo: function () {
      if (this.$store.socketOn){
        let liveItems = this.$store.state.inboxData.filter((obj) => { return obj.liveCall})
        let otherItems = this.$store.state.inboxData.filter((obj) => { return !obj.liveCall})

        function sortDate (a, b) {
          return new Date(b.lastCommsDate) - new Date(a.lastCommsDate)
        }
        return [...liveItems.sort(sortDate), ...otherItems.sort(sortDate)]
      } else {
        return this.$store.state.inboxData
      }
    }
  },
  methods: {
    getHash: function (request) {
      return crypto.createHmac("sha256", this.secret)
        .update(JSON.stringify(request))
        .digest("hex");
    },
    loadConversations: function () {
      this.$store.commit('clearInbox');
      let dataPromises = []
      dataPromises.push(this.getConversations())
      Promise.all(dataPromises)
        .then(async (results) => {
          await this.displayRecent()
          this.$store.commit('turnSocketOn')
        })
        .finally( () => {
          this.$store.commit('sortInbox') 
          this.$root.$emit('initiateDeepLinkHandler')
          
          if (this.vinDealercodes[this.currentAccount]) {
            this.checkVinIntegration(this.vinDealercodes[this.currentAccount])
          }
        })
    },
    loadConversationsSocketReconnect: function () {
      this.$store.commit('clearInbox');
      let dataPromises = []
      dataPromises.push(this.getConversations())
      Promise.all(dataPromises)
        .then(async (results) => {
          await this.displayRecent()
        })
        .finally( () => { 
          this.$store.commit('sortInbox') 
        })
    },
    deepLinkHandler: function () {
      let convoExist = this.inboxData.filter( (convo) => {
        return convo.conversationid === this.deepLinkConversationId;
      })

      if (convoExist.length) {
        let convo = convoExist[0];
        this.selectConvo(convo);
        this.$store.commit('markDeepLinkExecuted');
      } else {
        this.selectConvoById(this.deepLinkConversationId);
      }
    },
    campaignPopulateHandler: async function (lskinid, ani, campaignInfo) {
      let convoExist = this.inboxData.filter( (convo) => {
        return convo.lskinid == lskinid && convo.custNumber == ani
      })

      if (convoExist.length) {
        let convo = convoExist[0];
        this.selectConvo(convo, campaignInfo);
      } else {
        this.selectConvoByLskinAni(lskinid, ani, campaignInfo)
      }
    },
    // pauseAllAudio: function (view) {
    //   console.log('pause All')
    //   $('.playPause').attr('src', require('../assets/img/play-btn.png'))
    //   $('.playPause').removeClass('pause')

    //   this.waveformsArray.filter(function (obj) {
    //     return obj.isPlaying()
    //   }).forEach(function (obj) {
    //     obj.pause()
    //   })
    //   this.$emit('changeView', view)
    // },
    getAgentsData: async function (conversation) {
      let endpoint = '/accounts/'
      endpoint = endpoint + conversation.lskinid + '/users?phonecode'

      let res = await this.axios.get(endpoint, {
        responseType: 'json'
      })

      res.data.forEach(function (part, index, arr) {
        if (part.Phonecode && part.Phonecode.pc_avatar) {
          arr[index].Phonecode.pc_avatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${part.Phonecode.phonecodeid}.jpg`;
        }
      })

      return res.data
    },
    getAccountData: async function (conversation) {
      let endpoint = '/accounts/'
      endpoint = endpoint + conversation.lskinid

      let res = await this.axios.get(endpoint, {
        responseType: 'json'
      })

      return res.data
    },
    // showMore: function () {
    //   if (!this.mobileView) {
    //     var id = event.target.id
    //     var off = $('#' + id)
    //     var parent = off.parent()[0].getBoundingClientRect()
    //     var topPx =  String(parent.y - 100) + 'px'
    //     $('.convoItemExtraInfo').filter('#' + event.target.id).css('top', topPx)
    //     $('.convoItemExtraInfo').filter('#' + event.target.id).show()
    //   }
    // },
    // hideMore: function () {
    //   $('.convoItemExtraInfo').hide()
    // },
    toggleAll: function() {
      if(this.filteredLskins.length === this.options.length) {
        this.filteredLskins = [];
      } else {
        this.filteredLskins = this.options;
      }
    },
    getConversationData: async function (conversation) {  
      let endpoint = `//reporting.callmeasurement.com/conversations.cfc?method=getAni&lskinid=${conversation.lskinid}&ani=${conversation.custNumber}`;

      let res = await this.axios.get(endpoint, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return data 
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      });
      
      if( typeof res.data !== 'undefined') {
        res.data.forEach( (part, index, arr) => {
          var key, keys = Object.keys(part);
          var n = keys.length;
          var newobj={}
          while (n--) {
            key = keys[n];
            newobj[key.toLowerCase()] = part[key];
          }

          arr[index] = newobj;
        })
      }

      if (typeof res.data !== 'undefined') {
        res.data.forEach( (part, index, arr) => {
          if (part.dnisfunctionid === 2) {
            arr[index].inbound = false
          } else {
            arr[index].inbound = true
          }

          // Convert timestamps to synchronize with the rest of the application.
          let original = moment(arr[index].tz_datetime).toISOString();
          let timestampAfter = moment(arr[index].tz_datetime)
            .add((moment.tz.zone('America/Chicago').utcOffset(moment()) / 60 * -1, 'hours') - this.currentConvo.tzadjust - (new Date().getTimezoneOffset() / 60), 'hours')
            .toISOString();

          // Create objects to assign bare minimum information if applicable
          let phonecodeObject = {};
          let agentObject = {};
          if (part.frn_phonecodeid > 0) {
            phonecodeObject = {
              lename: part.lename,
              pc_avatar: part.pc_avatar,
              phonecodeid: part.frn_phonecodeid
            };
            agentObject = {
              Phonecode: phonecodeObject
            };
          } else {
            phonecodeObject = null;
            agentObject = null;
          }

          // Bind to the list of active agents for this account if the phonecode originated from this account
          // Otherwise just fill out the bare minimum information
          let agentInThisAccount = this.agents.filter( (agent) => agent.frn_phonecodeid === part.frn_phonecodeid)[0];
          if (agentInThisAccount) {
            arr[index].agent = agentInThisAccount;
            arr[index].agentSelected = part.agent;
          } else {
            arr[index].agent = agentObject;
            arr[index].agentSelected = agentObject;
          }

          arr[index].tz_datetime = timestampAfter
          arr[index].type = 1
          arr[index].datetime = moment(timestampAfter).format('LLL')
          arr[index].date = moment(timestampAfter).format('LL')
          arr[index].call_summ = ''
          arr[index].review_classid = []
          arr[index].Unaddressed = arr[index].unaddressed;

          delete arr[index].unaddressed;
          if (part.agent && part.agent.Phonecode && part.agent.Phonecode.pc_avatar) {
            arr[index].agent.Phonecode.pc_avatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${part.agent.Phonecode.phonecodeid}.jpg`;
          }
        })
      } 

      // Append text data to the object
      let object = await this.getTexts(conversation, res.data)

      // Append notes data to the object
      object = await this.getNotes(object)

      // Append unaddressed log data to the object
      object = await this.getUnaddressedLog(object);

      return object;
    },
    getUnaddressedLog: async function (conversationObject) {
      const endpoint = `/conversations/${conversationObject.conversation.lskinid}/${conversationObject.conversation.custNumber}/unaddressedLog`
      const object = { 'conversation': conversationObject.conversation, 'interactions': conversationObject.interactions}
      const res = await this.axios.get(endpoint);

      if (res && res.data && res.data.length) {
        const tempUnaddressedMap = {};
        res.data.map(log => tempUnaddressedMap[log.CommunicationId] ? tempUnaddressedMap[log.CommunicationId].push(log) : tempUnaddressedMap[log.CommunicationId] = [log]);
        this.$store.commit('storeUnaddressedLog', tempUnaddressedMap); 
      }
      
      return object
    },
    getNotes: async function (conversationObject) {
      let endpoint = `/conversations/${conversationObject.conversation.conversationid}/notes`
      let object = { 'conversation': conversationObject.conversation, 'interactions': conversationObject.interactions}
      let res = await this.axios.get(endpoint)

      if (res && typeof res.data !== 'undefined') {
        res.data.forEach((part, index, arr) => {
          let cstTimestamp = moment(arr[index].created).add(moment.tz.zone('America/Chicago').utcOffset(moment()) / 60 * -1, 'hours');
          arr[index].type = 4
          arr[index].formattedDate = moment(arr[index].created).format('LLL')
          arr[index].tz_datetime = cstTimestamp.toISOString().replace('Z','')
          arr[index].datetime = moment(arr[index].created).format('LLL')
          arr[index].date = moment.utc(arr[index].created).format('LL')
          object.interactions.push(arr[index])
        })
      }
      
      return object
    },
    getTexts: async function (conversation, callsObj) {
      let endpoint = `https://texting.callbox.com/v2/message/history?CustomerNumber=${conversation.custNumber}&Lskinid=${conversation.lskinid}`

      let object = { 'conversation': conversation, 'interactions': callsObj }

      let res = await this.axios.get(endpoint, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return data 
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Hash': this.getHash({})
        },
      });
     
      if (res && typeof res.data !== 'undefined') {      
        res.data.forEach( (part, index, arr) => {  
          if (part.Direction === 'inbound') {
            arr[index].inbound = true;
          } else if (part.Direction === 'outbound') {
            let image;
            arr[index].inbound = false;
            arr[index].agent = { Phonecode: {} };
            if (part.phonecodeid != null) {
              arr[index].agent.Phonecode = {
                lename: part.AgentName,
                pc_avatar: part.pc_avatar ? part.pc_avatar : '',
              }
            } else {
              arr[index].agent.Phonecode = {}
              arr[index].agent.Phonecode.lename = part.AgentName
            }
          }

          var imageTypes = ["jpg", "jpeg", "png", "gif"];
          var videoTypes = ["mp4", "avi", "m4v", "mpg", "mpeg", "mov"]
          if (part.file1 != undefined) {
            if (imageTypes.includes(part.file1Type)) {
              arr[index].hasAttachment1 = true;
              arr[index].attachmentType1 = "image";
            } else if (videoTypes.includes(part.file1Type)) {
              arr[index].hasAttachment1 = true;
              arr[index].attachmentType1 = "video";
            } else {
              arr[index].hasAttachment1 = true;
              arr[index].attachmentType1 = "other";
            }
          }

          if (part.file2 != undefined) {
            if (imageTypes.includes(part.file2Type)) {
              arr[index].hasAttachment2 = true;
              arr[index].attachmentType2 = "image";
            } else if (videoTypes.includes(part.file2Type)) {
              arr[index].hasAttachment2 = true;
              arr[index].attachmentType2 = "video";
            } else {
              arr[index].hasAttachment2 = true;
              arr[index].attachmentType2 = "other";
            }
          }
          let utcTimestamp = moment(arr[index].Timestamp).add(moment.tz.zone('America/Chicago').utcOffset(moment()) / 60, 'hours');
          arr[index].body = arr[index].Body;
          arr[index].tz_datetime = (arr[index].Timestamp).replace('Z','')
          arr[index].datetime = utcTimestamp.format('LLL');
          arr[index].date = utcTimestamp.format('LL')
          arr[index].frn_zwid = arr[index].SmsLineId;
          arr[index].sendStatus = arr[index].isSent;
          delete arr[index].pc_avatar;
          delete arr[index].AgentName;
          delete arr[index].Timestamp;
          delete arr[index].Direction;
          delete arr[index].SmsLineId;
          delete arr[index].isActive;
          delete arr[index].Body;
          callsObj.push(arr[index])      
        })
        object = { 'conversation': conversation, 'interactions': callsObj};
      } else {
        console.log('No text data for this customer.')
      }
      return object;
    },
    getValidLines: async function(conversation) {
      const consentCheck = await this.axios.get(`https://texting.callbox.com/v2/api/consent?customerNumber=${conversation.custNumber}&lskinid=${conversation.lskinid}`, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return data 
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Hash': this.getHash({})
        },
      })

      if (consentCheck.data) {
        this.$store.commit({
          type: 'storeConsent',
          consent: consentCheck.data
        }) 
      } else {
        this.$store.commit({
          type: 'storeConsent',
          consent: undefined
        }) 
      }
      
      let endpoint = `https://texting.callbox.com/v2/api/lines?lskinid=${conversation.lskinid}&userid=${this.user.leuserid}`;
      let lineData = [];
      let res = await this.axios.get(endpoint, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return data 
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Hash': this.getHash({})
        },
      });

      if (typeof res.data !== 'undefined' && res.data.length > 0) {
        for (let i = 0; i < res.data.length; ++i) {
          const info = {
            zwid: res.data[i].SmsLineId, 
            dnisid: res.data[i].dnisid,
            label1: res.data[i].label1,
            lednis: res.data[i].lednis,
            displaynum: res.data[i].displaynum,
            agentLine: res.data[i].AgentLine,
            latestMessage: res.data[i].Timestamp,
            isPoolNumber: res.data[i].isPoolNumber,
            isActive: res.data[i].isActive
          };
          lineData.push(info)
        }
      }
      this.$store.commit({
        type: 'updateValidTextLines',
        id: lineData
      });
    },
    updateView: async function (convoid) {
      /** set end timestamp of previously viewed convo */
      if (this.currentConvoViewId != 0) {
        let endpoint = `/conversations/viewsUpdate`;
        let res = await this.axios.post(endpoint, {
          id: this.currentConvoViewId,
          end: 1,
          opened: 0
        }).then(res =>{
             
        });
      }
    },       
    createView: async function (convoid,lid,ani) {
      let endpoint = `/conversations/views`;
      let res = await this.axios.post(endpoint, {
          id: convoid,
          leuserid: this.user.leuserid,
          lskinid: lid,
          customerani: ani
      }).then(res =>{
          this.$store.commit({
            type: 'updateConvoViewId',
            id: res.data
          })                  
      });
    },
    markRead: async function (Accounts, SmsUserId, CustomerNumber, SmsInboundId) {
      const endpoint =  `https://texting.callbox.com/v2/message/read`

      const request = {
        Accounts: Accounts,
        SmsUserId: SmsUserId,
        CustomerNumber: CustomerNumber,
        SmsInboundId: SmsInboundId
      }

      let res = await this.axios.post(endpoint, request, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return JSON.stringify(data)
          }
        ],
        headers: {
          'Content-Type': 'application/json',
          'Hash': this.getHash(request),
        },
      })
    },
    markReadCustomer: async function (Accounts, SmsUserId, CustomerNumber) {
      const endpoint =  `https://texting.callbox.com/v2/message/read/customer`

      const request = {
        Accounts: Accounts,
        SmsUserId: SmsUserId,
        CustomerNumber: CustomerNumber
      }

      let res = await this.axios.post(endpoint, request, {
        transformRequest: [
          (data, headers) => { 
            delete headers.common.Authorization; return JSON.stringify(data)
          }
        ],
        headers: {
          'Content-Type': 'application/json',
          'Hash': this.getHash(request),
        },
      })
    },
    populateCampaignInformation: function (item) {
      // Pull all relevant campaigns for a given customer phonenumber -- that the logged in user has access to
      const campaignInfo = [];
      const associatedCampaigns = this.aniToCampaignMap[item.custNumber];
      if (associatedCampaigns) {
        for (const campaign of associatedCampaigns) {
          const tempLabels = [];
          for (let columnNumber = 1; columnNumber <= 10; columnNumber++) {
            if (campaign[`Header${columnNumber}`]) {
              tempLabels.push({
                label: campaign[`Header${columnNumber}`],
                data: campaign[`Column${columnNumber}`]
              })
            }
          }
          campaignInfo.push({
            campaignName: campaign.campaignName,
            campaignLabels: tempLabels,
            expanded: false
          });
        }
      }

      return campaignInfo;
    },
    selectConvo: async function (item, campaignInfo) {    
      // Clear customer info section
      this.clearCallerNotes();

      // Check if campaign info should be appended -- if not already passed
      if (!campaignInfo) {
        campaignInfo = this.populateCampaignInformation(item);
      }

      // Track conversationid for preventing race conditions.
      this.$store.commit({
        type: 'trackConvoId',
        conversationId: item.conversationid
      })

      // Emit event that a conversation was selected.
      this.$root.$emit('convoSelected', {})

      // Update state of previous conversation and the current one selected.
      this.$store.commit({
        type: 'loadConversation',
        setting: true
      })
      let inboxItem = this.inboxData[this.inboxData.findIndex(obj => obj.conversationid === this.currentConvo.conversationid)]
      if(inboxItem) { inboxItem.selected = false }
      this.currentConvo.selected = false
      item.selected = true
      item.unaddressed = false
      this.currentConvo = item

      let query45 = false;

      // Track conversation views
      this.updateView()
      this.createView(this.currentConvo.conversationid, this.currentConvo.lskinid, this.currentConvo.custNumber)
      this.markReadCustomer([this.currentConvo.lskinid], this.user.leuserid, this.currentConvo.custNumber)

      // reset selected ob text line
      this.$store.commit({
        type: 'updateSelectedTextLine',
        lineObj: 0
      })

      // Update current account value with the one from the store cache
      this.$store.commit({
        type: 'updateCurrentAccount',
        account: item.lskinid
      })

      // Load in resources ( knowledge management ) for the account / selected conversation.
      this.$store.dispatch('populateResourcesAsync', item.lskinid)

      // Can eventually do the same for agent data probably.
      // Grab agent data for this CONVERSATION
      let agentsPromises = []
      agentsPromises.push(this.getAgentsData(item))
      Promise.all(agentsPromises).then((results) => {
        this.$store.commit({
          type: 'updateAgentsData',
          users: results[0]
        })
      })

      // Grab call data for this CONVERSATION
      let dataPromises = []
      dataPromises.push(this.getConversationData(item))

      this.getValidLines(item)

      // Dispatch actions as necessary for call information.
      let loadPromises = []
      loadPromises.push(
        Promise.all(dataPromises)
          .then(async (results) => {
            await this.$store.dispatch('populateConversation', {conversations: results[0], conversationid: item.conversationid})
          })
          .finally(async () => {
            // Kick off non-blocking async requests here
            let callids = [];
            for(let call of this.$store.state.currentMessages) {
              callids.push(call.callid);
            }
            
            this.$store.dispatch('populateConversationAsync', callids)

            await this.retrieveCallerNotes(false, !!this.vinDealercodes[item.lskinid], true);

            if (!!this.vinDealercodes[item.lskinid]) {
              this.retrieveVINInformation(this.vinDealercodes[item.lskinid]);
              this.isDS = false;
              this.isVin = true;
              this.isElead = false;
            };

            await this.retrieveCallerNotes(!!this.dsDealercodes[item.lskinid], false, true);
            if (!!this.dsDealercodes[item.lskinid]) {
              this.retrieveDSInformation(this.dsDealercodes[item.lskinid]);
              if (this.dsDealercodes.length > 5) {
                this.isDS = true;
                this.isVin = false;
                this.isElead = false;
              } 
            }

            if(!!this.eleadDealercodes[item.lskinid]) {
              this.retrieveEleadInformation();
              this.isElead = true
              this.isDS = false;
              this.isVin = false;
            }

            // NEXHEALTH
            if (this.nexhealthLskins.indexOf(item.lskinid) != -1) {
              this.retrieveNexHealthInformation(item.lskinid);
            }
          })
      )

      // Trigger a scroll after calls are finished loading.
      Promise.all(loadPromises).then((results) => {
        this.scrollMessages()
      })

      // Update current thread values
      await this.updateCurrentThread(campaignInfo);

      // Emit event to trigger getCrm function from liveCallMod
      this.$root.$emit('loadCrm')

      // if on mobile view, hide sidebar once a convo has been chosen 
      if (this.mobileView) {
       this.$emit('showHideSide')
      }

    },
    selectConvoById: async function (conversationid) {
      //If the conversation doesn't already exist in the side bar, load it into the side bar and select it.
      // Get conversation from API
      let res = await this.axios.post('/conversations/getConversations?search=', {
        lskins: this.filteredLskins,
        id: conversationid
      });

      let dnisMap = await this.createDnisMap(res.data);
      let conversation = await this.createSidebarObject(res.data[0], dnisMap);

      if (typeof conversation !== 'undefined') {
        this.$store.commit({
          type: 'addToInbox',
          message: conversation
        })
      }

      this.selectConvo(conversation);    
      this.$store.commit('markDeepLinkExecuted');  
    },
    selectConvoByLskinAni: async function (lskin, ani, campaignInfo) {
      // If the conversation doesn't already exist in the side bar, load it into the side bar and select it.
      // Get conversation from API
      let res = await this.axios.post(`/conversations/getConversations?search=${ani}`, {
        lskins: lskin
      });
      
      let dnisMap = await this.createDnisMap(res.data);
      let conversation = await this.createSidebarObject(res.data[0], dnisMap);

      if (typeof conversation !== 'undefined') {
        this.$store.commit({
          type: 'addToInbox',
          message: conversation
        })
      }

      this.selectConvo(conversation, campaignInfo);
    },
    retrieveCallerName: async function () {
      let endpoint = `/conversations/${this.currentConvo.custNumber}/callerName`
      let res = await this.axios.get(endpoint, {})
      .then( (response) => {
        if (response.data.ani_name) {
          this.$store.commit({
            type: 'setCDKName',
            custName: response.data.ani_name
          })
        } else {
          this.$store.commit({
            type: 'setCDKName',
            custName: 'Customer'
          })
        }
      })
    },
    checkVinIntegration: async function(dealercode){
      let skipRateLimit = true
      let currentNumber = this.inboxData[0].custNumber;
      let endpoint = `/integrations/findContact/${currentNumber}/${dealercode}/${skipRateLimit}`;
      let response = await this.axios.get(endpoint);
      if (response.data && response.data == 'User is not authorized'){
        this.vinintegrationalert = true
      }
    },

    retrieveVINInformation: async function (dealercode) {
      let currentNumber = this.currentConvo.custNumber;
      let currentAccount = this.currentConvo.lskinid;
      let skipRateLimit = false
      let endpoint = `/integrations/findContact/${currentNumber}/${dealercode}/${skipRateLimit}`;
      let customerName = await this.axios.get(endpoint);

      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        await this.retrieveCallerNotes(false, true, false)
        if (customerName && customerName.data && customerName.data.trim().length && !this.vinintegrationalert) {
        this.currentConvo.name = customerName.data;
        this.currentThread.name = customerName.data;
        }
      }
    },
    retrieveDSInformation: async function () {
      let currentNumber = this.currentConvo.custNumber;
      let currentAccount = this.currentConvo.lskinid;
      // http://localhost:3334/customer/7199921454/150214/dealersocket or https://callmeasurement-api.callbox.com
      let endpoint = `https://callmeasurement-api.callbox.com/customer/${currentNumber}/${currentAccount}/dealersocket`;
      let customerName = await this.axios.get(endpoint);

      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        await this.retrieveCallerNotes(true, false, false)
        if (customerName && customerName.data && customerName.data.length) {
        this.currentConvo.name = customerName.data;
        this.currentThread.name = customerName.data; 
        }
      }
    },
    retrieveEleadInformation: async function () {
      let currentNumber = this.currentConvo.custNumber;
      let currentAccount = this.currentConvo.lskinid;
      // http://localhost:3334/customer/${currentNumber}/${currentAccount}/elead or https://callmeasurement-api.callbox.com
      let endpoint = `https://callmeasurement-api.callbox.com/customer/${currentNumber}/${currentAccount}/elead`;
      let leadData = await this.axios.get(endpoint);

      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        await this.retrieveCallerNotes(false, false, false);
      }
    },
    clearCallerNotes: function () {
      this.$store.commit('setNoteData', { hasVinInfo: false, hasDSInfo: false });
    },
    retrieveCallerNotes: async function (isDS, isVin, initialLookup) {
      let currentNumber = this.currentConvo.custNumber;
      let currentAccount = this.currentConvo.lskinid;
      let endpoint = `/conversations/${currentNumber}/${currentAccount}/callerNotes`
      let res = await this.axios.get(endpoint);

      const notes = res.data;
      const NoteData = {
        hasDSInfo: isDS ? true : false,
        hasVinInfo: isVin ? true : false,
        hasInfo: notes.length || this.isElead ? true : false,
        displaySalesPerson: false,
        displayServicePerson: false,
        displayCalendarSales: false,
        displayCalendarService: false,
        displayCalendarServiceRed: false,
        displayCar1: false,
        displayCar1Red: false,
        displayCar2: false,
        displayWrench: false,
        displayCustomerName: ''
      };
      let activeLead = false;

      if (notes.length) {
        notes.map(note => {
          const dateDiff = moment().diff(moment(note.NoteDate), 'days');

          // Service person icon
          if (!NoteData.displayServicePerson && note.NoteTypeID == 8)  {
            NoteData.displayServicePerson = note.Note;
          }

          // Sales person icon
          if (!NoteData.displaySalesPerson && note.NoteTypeID == 9)  {
            NoteData.displaySalesPerson = note.Note;
          }

          // Service appt
          if (dateDiff <= 30 && !NoteData.displayCalendarService && note.NoteTypeID == 3) {
            const noteDatetime = moment(note.Note).add(moment.tz.zone('America/Chicago').utcOffset(moment(note.Note)) / 60, 'hours').format('MM/DD/YYYY h:mma');
            NoteData.displayCalendarService = noteDatetime && noteDatetime != 'Invalid date' ? noteDatetime : note.Note;

            if (note.Note == 'Service Appt Missed' || note.Note == 'Service Appt Cancelled') {
              NoteData.displayCalendarServiceRed = true;
            }
          }

          // Sales appt
          if (dateDiff <= 30 && !NoteData.displayCalendarSales && note.NoteTypeID == 5) {
            const noteDatetime = moment(note.Note).add(moment.tz.zone('America/Chicago').utcOffset(moment(note.Note)) / 60, 'hours').format('MM/DD/YYYY h:mma');
            NoteData.displayCalendarSales = noteDatetime && noteDatetime != 'Invalid Date' ? noteDatetime : note.Note;
          }

          // Car icon
          if (!activeLead && (note.NoteTypeID == 1 || note.NoteTypeID == 10 || note.NoteTypeID == 15)) {
            NoteData.displayCar1 = note.Note;

            if (note.NoteTypeID == 1 || note.NoteTypeID == 15) {
              activeLead = true;
            }
          }

          // Second car icon
          if (note.NoteTypeID == 6) {
            NoteData.displayCar2 = note.Note;
          }

          // Wrench icon
          if (dateDiff <= 30 && note.NoteTypeID == 4) {
            NoteData.displayWrench = note.Note;
          }

          //Customer Name
          if (note.NoteTypeID == 11 && note.Note != '' && note.Note.length > 4)  {
            NoteData.displayCustomerName = note.Note;
          }

          // Helper flag.
          for (const key in NoteData) {
            if (NoteData[key]) {
              if (isVin) {
                NoteData.hasVinInfo = true;
              } else if (isDS) {
                NoteData.hasDSInfo = true;
              }
              break;
            }
          }
        });
      }

      if (!activeLead) {
        NoteData.displayCar2 = false;
      }

      if (isVin && !NoteData.displayCar1 && !this.vinintegrationalert) {
        NoteData.displayCar1 = initialLookup ? 'Fetching CRM data...' : 'No Active Lead in CRM';
        NoteData.displayCar1Red = initialLookup ? NoteData.displayCar1Red : true;
      } else if (isVin && NoteData.displayCar1 && !activeLead && NoteData.displayCar1.indexOf('Sold') == -1 && !this.vinintegrationalert) {
        NoteData.displayCar1 = 'No Active Lead in CRM';
        NoteData.displayCar1Red = true;
      } else if (this.vinintegrationalert){
        NoteData.displayCar1 = 'VIN Integration Not Set Up Correctly'
        NoteData.displayCar1Red = true;
      } else if (this.isElead && !activeLead){
        NoteData.displayCar1 = 'No Active Lead in CRM';
        NoteData.displayCar1Red = true;
      }
      
      if (isDS == true && !NoteData.displayCar1) {
        NoteData.displayCar1 = initialLookup ? 'Fetching CRM data...' : 'No Active Lead in CRM';
        NoteData.displayCar1Red = initialLookup ? NoteData.displayCar1Red : true;
      } else if (isDS == true && NoteData.displayCar1 && !activeLead  && NoteData.displayCar1.indexOf('Sold') == -1) {
        NoteData.displayCar1 = 'No Active Lead in CRM';
        NoteData.displayCar1Red = true;
      }     
      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        this.$store.commit('setNoteData', NoteData);
      }
    },
    retrieveNexHealthInformation: async function (dealercode) {
      let currentNumber  = this.currentConvo.custNumber;
      let currentAccount = this.currentConvo.lskinid;
      const res = await this.axios.get(`/integrations/nexhealth/${currentNumber}/${currentAccount}`);

      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        if (res.data.length > 0) {
          let isNexalth    = (res.data[0]['patientId']) ? true : false;
          await this.retrieveAppointmentNotes(isNexalth);
        }
      }
    },
    retrieveAppointmentNotes: async function (isNexalth) {
      let currentNumber = this.currentConvo.custNumber;
      let currentAccount= this.currentConvo.lskinid;
      let endpoint = `/conversations/${currentNumber}/${currentAccount}/appointmentDate`
      let res = await this.axios.get(endpoint);
      const appointments = res.data;

      let endpointTimeAdjust  = `/conversations/${currentAccount}/letimeAdjust`
      let resTimeAdjust       = await this.axios.get(endpointTimeAdjust);
      const dataTimeAdjust    = resTimeAdjust.data;

      const NoteAppointmentData = {
        hasInfo: isNexalth ? true : false,
        displayAppointment: false,
        displayAppointmentRed: false,
      };

      if (appointments.length > 0) {
          if (appointments[0].appointmentDate) {
            let timeAdjust  = (dataTimeAdjust[0].letimeadjust != '') ? dataTimeAdjust[0].letimeadjust : 0;
            let zoneCST     = moment(appointments[0].appointmentDate).utcOffset("-06:00");
            NoteAppointmentData.displayAppointment = 'Appointment info: ' + zoneCST.add(timeAdjust, 'h').format('MM-DD h:mma');
            NoteAppointmentData.displayAppointmentRed = false;
          } 
      } else {
        NoteAppointmentData.displayAppointment    = 'No Future Appointment in CRM';
        NoteAppointmentData.displayAppointmentRed = true;
      }

      // Don't want to populate this info if the user switched conversations.
      if (currentNumber == this.currentConvo.custNumber && currentAccount == this.currentConvo.lskinid) {
        this.$store.commit('setNoteData', NoteAppointmentData);
      }
    },
    updateCurrentThread: function (campaignInfo) {
      if (this.currentConvo.name.indexOf(this.currentConvo.custNumber.substring(6, 10)) === -1) {
        this.currentThread.name = this.currentConvo.name
        this.currentThread.shortName = this.currentConvo.name.substring(0, 1) + this.currentConvo.name.substring(this.currentConvo.name.indexOf(' ') + 1, this.currentConvo.name.indexOf(' ') + 2)
      } else {
        this.currentThread.name = 'Customer'
        this.currentThread.shortName = ''
      }

      var s2 = ('' + this.currentConvo.custNumber).replace(/\D/g, '')
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      var callerNumber = (!m) ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3]
      this.currentThread.phone = callerNumber
      this.currentThread.conversationid = this.currentConvo.conversationid
      this.currentThread.isLive = this.currentConvo.liveCall
      this.currentThread.campaigns = campaignInfo ? campaignInfo : false

      this.$store.commit({
        type: 'updateCurrentThread',
        conversationid: this.currentThread.conversationid,
        editMode: false,
        name: this.currentThread.name,
        shortName: this.currentThread.shortName,
        isLive: this.currentThread.isLive,
        phone: this.currentThread.phone,
        status: 'Appt. May 30, 2018', 
        audioState: 'new',
        custNumber: this.currentConvo.custNumber,
        lskinid: this.currentConvo.lskinid,
        campaigns: campaignInfo ? campaignInfo : false
      })
      this.$store.commit({
        type: 'setFollowers',
        conversationid: this.currentThread.conversationid
      })
    },
    clearSearch: function () {
      if (this.searchbarVal !== '') {
        this.searchbarVal = ''
        this.goSearch()
        this.showClearSearch = false
      }
    },
    formatTimestamp: function (timestamp) {
      let interactionTime = timestamp.substring(11, timestamp.length).substring(0, 5)
      let interactionDate = timestamp.substring(0, 10)
      let interactionHour = interactionTime.substring(0, 2)
      let today = (new Date().toDateString())
      let currentYear = today.substring(11, today.length)
      let currentDay = today.substring(8, 10)
      let currentMonth = ''

      if (today.substring(4, 7) === 'Jan') {
        currentMonth = '01'
      } else if (today.substring(4, 7) === 'Feb') {
        currentMonth = '02'
      } else if (today.substring(4, 7) === 'Mar') {
        currentMonth = '03'
      } else if (today.substring(4, 7) === 'Apr') {
        currentMonth = '04'
      } else if (today.substring(4, 7) === 'May') {
        currentMonth = '05'
      } else if (today.substring(4, 7) === 'Jun') {
        currentMonth = '06'
      } else if (today.substring(4, 7) === 'Jul') {
        currentMonth = '07'
      } else if (today.substring(4, 7) === 'Aug') {
        currentMonth = '08'
      } else if (today.substring(4, 7) === 'Sep') {
        currentMonth = '09'
      } else if (today.substring(4, 7) === 'Oct') {
        currentMonth = '10'
      } else if (today.substring(4, 7) === 'Nov') {
        currentMonth = '11'
      } else if (today.substring(4, 7) === 'Dec') {
        currentMonth = '12'
      }

      if (interactionDate === (currentYear + '-' + currentMonth + '-' + currentDay)) {
        if (interactionHour <= 9) {
          interactionTime = interactionTime.substring(1, timestamp.length) + ' am'
        } else if (interactionHour > 9 && interactionHour < 12) {
          interactionTime = interactionTime + ' am'
        } else if (interactionHour == 12) {
          interactionTime = interactionTime + ' pm'
        } else if (interactionHour >= 13 && interactionHour < 22) {
          interactionTime = (interactionHour - 12) + interactionTime.substring(2, 5) + ' pm'
        } else if (interactionHour >= 22) {
          interactionTime = (interactionHour - 12) + interactionTime.substring(2, 5) + ' pm'
        }
      } else {
        interactionTime = interactionDate.substring(5).replace('-', '/') + '/' + interactionDate.substring(2, 4)
      }
      return interactionTime
    },
    formatName: function (aniname, aninum) {
      let callerLabel = ''
      if (aniname) {
        if (aniname.indexOf(',') > -1) {
          callerLabel = aniname.split(',');
          var firstName = callerLabel[1];
          var lastName = callerLabel[0];
          callerLabel = firstName + ' ' + lastName;
        } else {
          callerLabel = aniname;
	      }
      } else {
        callerLabel = aninum
        var s2 = ('' + callerLabel).replace(/\D/g, '')
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
        callerLabel = (!m) ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3]
      }
      return callerLabel
    },
    getConversations: async function () {
      let endpoint = '/conversations/getConversations'
      let url = endpoint;

      // 'Load more' handling
      if (this.loadMoreStart === '') {
        this.$store.commit({
          type: 'loadInbox',
          setting: true
        })
      } else {
        this.$store.commit({
          type: 'loadMoreInbox',
          setting: true
        })
      }

      // Append variables specifying chosen filters to the conversations API call
      let ownedby, followedby, unaddressed, noFollowers, phonecodeGroup, linesToFilter;
      switch(this.selectedFilter) {
        case 'My Convos':
          ownedby = this.user.leuserid;
          break;
        case 'Following':
          followedby = this.user.leuserid;
          break;
        case 'Unaddressed':
          unaddressed = true;
          break;
        case 'Following & New':
          noFollowers = this.user.leuserid;
          break;
        default:
          // console.log('No filters passed!');
          break;
      }

      // Special case handling for dynamic phonecode group filters
      if (this.selectedPhonecodeGroup) {
        noFollowers = this.user.leuserid;
        phonecodeGroup = this.selectedPhonecodeGroup;
      }

      // Special case handling for Dwyer line filtering
      if (this.filterLines) {
        linesToFilter = Object.keys(this.linesToFilter);
      }

      // Append search query params if relevant
      if (this.searchStr !== '') {
        url = url + '?search=' + this.searchStr
      } else {
        url = url + '?search='
      }
      if (this.loadMoreStart !== '') {
        url = url + '&start=' + this.loadMoreStart
      }

      let res = await this.axios.post(url, {
        lskins: this.filteredLskins,
        ownedby: ownedby,
        followedby: followedby,
        unaddressed: unaddressed,
        noFollowers: noFollowers,
        phonecodeGroup: phonecodeGroup,
        userPhonecode: this.user.Phonecode ? this.user.Phonecode.phonecodeid : undefined,
        isManager: this.liveButton,
        linesToFilter
      })

      if (res.data && res.data.length) {
        this.oldestConversation = res.data[res.data.length - 1].interaction.latestInteractionTime;
      }

      this.queryData = res.data || [];
    },
    scrollMessages: function () {
      var myElement = document.querySelector('.messages-container')
      myElement.scrollTop = myElement.scrollHeight
    },
    appendDnisInformation: async function (dnisid, msg, dnisMap) {
      return new Promise ( async (resolve, reject) => {
        try {
          const dnisObj = msg.interaction.dnis;

          switch(msg.interaction.type) {
            case 'Call':
              msg.dnisIcon = 'phone';
              msg.dnisType = msg.interaction.direction === 'inbound' ? 'IB' : 'OB';
              msg.dnisTypeDb = msg.interaction.direction === 'inbound' ? 'inbound' : 'outbound';
              break;
            case 'Text':
              msg.dnisIcon = 'message'
              msg.dnisType = msg.interaction.direction == 'inbound' ? 'IB' : 'OB'
              msg.dnisTypeDb = msg.interaction.direction == 'inbound' ? 'inbound' : 'outbound'
              break;
            case 'Note':
              msg.dnisIcon = 'edit'
              msg.dnisType = 'Note'
              msg.dnisTypeDb = 'note'
              break;
            case 'Facebook':
              break;
            case 'Voicemail':
              break;
            default:
              console.log('Not a valid document type!');
          }

          if (dnisObj) {
            msg.dnisLabel = dnisObj.label1;
            msg.tzadjust = dnisObj.tzadjust;
            msg.displaynum = dnisObj.displaynum;
          } else {
            // contingency request to get dnis info for this dnisid
            let dnisInfo = dnisMap[dnisid];
            if (dnisInfo) {
              msg.dnisLabel = dnisInfo.label1;
              msg.tzadjust = dnisInfo.tzadjust;
              msg.displaynum = dnisInfo.displaynum;
            }
          }
        
          resolve(msg);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    displayRecent: async function (searchKey) {
      return new Promise ( async (resolve, reject) => {
        if (this.loadMoreStart === '') {
          this.$store.commit({
            type: 'loadInbox',
            setting: false
          })
        } else {
          this.$store.commit({
            type: 'loadMoreInbox',
            setting: false
          })
        }
        let sliceEndValue = (this.loadMoreStart === '') ? 30-this.$store.state.inboxData.length : 30
        let results = this.queryData.slice(0, sliceEndValue)
        let searchArr = []
        let temp = {
          conversation: {},
          name: '',
          custNumber: '',
          tlInfo: '',
          type: 'note',
          icon: 'event_note',
          sneak: '',
          lskinid: '',
          liveCall: false,
          unaddressed: false,
          selected: false,
          handledByMe: false,
          displayTime: '',
          lastCommsDate: '',
          conversationid: 354,
          tzadjust: 0,
          latestInteractionName: '',
          latestInteractionAvatar: '',
          latestInteractionPhonecode: 0
        }

        if (results) {
          let dnisMap = await this.createDnisMap(results);

          for (let i of results) {
            // Prevent duplicates in sidebar
            let convoExist = this.inboxData.filter( (convo) => {
              return convo.conversationid === i._id;
            })
            if(convoExist.length){
              continue;
            }

            temp = await this.createSidebarObject(i, dnisMap);

            if (typeof temp !== 'undefined') {
              this.$store.commit({
                type: 'addToInbox',
                message: temp
              })
            }

            temp = {
              name: 'Resetting Temp',
              custNumber: '',
              tlInfo: '',
              type: 'note',
              icon: 'event_note',
              sneak: '',
              lskinid: '678',
              liveCall: false,
              unaddressed: false,
              selected: false,
              handledByMe: false,
              displayTime: '2:12 pm',
              lastCommsDate: '',
              conversationid: 0,
              tzadjust: 0,
              latestInteractionName: '',
              latestInteractionAvatar: '',
              latestInteractionPhonecode: 0
            }
          }
        }
        resolve();
      })
    },
    createSidebarObject: async function (conversation, dnisMap){
      let interactionType;
      let sneakStr;
      let latestInteractionName;
      let latestInteractionAvatar;
      let latestInteractionPhonecode;
      let attachment;
      let attachmentType;
      let nodeIP;

      let temp = {
        conversation: {},
        name: '',
        custNumber: '',
        tlInfo: '',
        type: 'note',
        icon: 'event_note',
        sneak: 'Needs to be called tomorrow at 4PM',
        lskinid: '678',
        liveCall: false,
        unaddressed: false,
        selected: false,
        handledByMe: false,
        displayTime: '2:12 pm',
        lastCommsDate: '',
        conversationid: 354,
        tzadjust: 0,
        latestInteractionName: '',
        latestInteractionAvatar: '',
        latestInteractionPhonecode: 0
      }

      switch(conversation.interaction.type) {
        case 'Call':
          interactionType = 'call'
          sneakStr = conversation.hcatCondensed
          latestInteractionName = conversation.interaction.call.lename;
          if (conversation.interaction.call.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${conversation.interaction.call.phonecodeid}.jpg`
          }
          latestInteractionPhonecode = conversation.interaction.call.phonecodeid;
          nodeIP = conversation.interaction.call.asteriskIP;
          break;
        case 'Text':
          interactionType = 'text'
          sneakStr = conversation.interaction.text.body
          latestInteractionName = conversation.interaction.text.lename;
          if (conversation.interaction.text.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${conversation.interaction.text.phonecodeid}.jpg`
          }
          latestInteractionPhonecode = conversation.interaction.text.phonecodeid;
          if (conversation.interaction.text.attachment !== null) {
            if (conversation.interaction.text.attachment.length) {
              attachment = conversation.interaction.text.attachment;  
              var initUrl = attachment[0];
              initUrl = initUrl.substring(initUrl.lastIndexOf('/')+1);
              var fileType = initUrl.split('.').pop();
              var imageTypes = ["jpg","jpeg","gif","png"];
              var videoTypes = ["mp4","mov","avi","mpg","mpeg"];
              if (imageTypes.includes(fileType)) {
                attachmentType = "image";
              } else if (videoTypes.includes(fileType)) {
                attachmentType = "video";
              }
            }
          }
          break;
        case 'Note':
          interactionType = 'note'
          sneakStr = conversation.interaction.note.text
          latestInteractionName = conversation.interaction.note.username;
          if (conversation.interaction.note.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${conversation.interaction.note.phonecodeid}.jpg`
          }
          latestInteractionPhonecode = conversation.interaction.note.phonecodeid;
          break;
        case 'Facebook':
          //
          break;
        case 'Voicemail':
          //
          break;
        default:
          console.log('Not a valid document type!');
      }

      conversation = await this.appendDnisInformation(conversation.interaction[interactionType].dnisId, conversation, dnisMap)

      temp.conversation = conversation
      temp.name = this.formatName(conversation.customerName, conversation.anis[0]._id)
      temp.custNumber = conversation.anis[0]._id
      temp.tlInfo = conversation.dnisLabel
      temp.type = conversation.dnisType
      temp.icon = conversation.dnisIcon
      temp.sneak = sneakStr
      temp.lskinid = conversation.accountId
      temp.liveCall = interactionType === 'call' ? !conversation.interaction.call.completed : false
      temp.unaddressed = conversation.unaddressed
      temp.selected = false
      temp.handledByMe = false
      temp.displayTime = this.formatTimestamp(moment(conversation.interaction[interactionType].timestamp).format())
      temp.lastCommsDate = conversation.interaction.latestInteractionTime
      temp.conversationid = conversation._id
      temp.interactionid = conversation.interaction[interactionType]._id
      temp.tzadjust = conversation.tzadjust
      temp.displayNum = conversation.displaynum,
      temp.latestInteractionName = latestInteractionName
      temp.latestInteractionAvatar = latestInteractionAvatar
      temp.latestInteractionPhonecode = latestInteractionPhonecode
      temp.attachment = attachment
      temp.attachmentType = attachmentType
      temp.nodeIP = nodeIP
      temp.unaddressedConvo = conversation.containsUnaddressed

      return temp;
    },
    createDnisMap: async function(conversations){
      let dnisids = conversations.filter(i => ((i.interaction.dnis && !i.interaction.dnis.tzadjust) || (!i.interaction.dnis)) && i.interaction.call && i.interaction.call.completed === false).map(i => i.interaction.call.dnisId);
      let dnisInfo = {};
      let dnisMap = {};

      if (dnisids.length) {
        dnisInfo = await this.axios.post('/dnis', { dnisids });
      }
      
      if (dnisInfo.data && dnisInfo.data.length) {
        dnisInfo.data.map(dnis => dnisMap[dnis.dnisid] = dnis);
      }

      return dnisMap;
    },
    goSearch: function () {
      this.showClearSearch = true;
      this.searchStr = this.searchbarVal.replace('(', '').replace(')', '').trim().replace(/ /g, '%25').replace(/-/g, '%25')
      this.loadMoreStart = '';
      this.$store.commit('clearInbox');

      let dataPromises = []
      dataPromises.push(this.getConversations())

      Promise.all(dataPromises)
        .then(async (results) => {
          console.log('Finished loading data')
          await this.displayRecent('search');
        })
        .finally(() => {
          this.$store.commit('sortInbox');
        });
    },
    loadMore: async function () {
      this.loadMoreStart = this.oldestConversation;

      let dataPromises = []

      dataPromises.push(this.getConversations())
      Promise.all(dataPromises).then(async (results) => {
        console.log('Finished loading data')
        await this.displayRecent()
      })
      .finally( () => {
        this.$store.commit('sortInbox')
      })
    },
    multiAccountSelectToggle: function() {
      this.multiAccountSelect = true;
    },
    closeMultiSelect: async function() {
      this.loadMoreStart = '';
      await this.$socket.emit('leave-room', this.lskins);
      await this.$socket.emit('join-room', this.filteredLskins);
      this.$store.commit('setDeepLinkConversationId', { id: '' });
      this.updateFilter('Following & New');
      this.multiAccountSelect = false;
    },
    opendd: function() {
      if (!this.ddOpen) {
        this.ddOpen = true
      } else {
        this.ddOpen = false;
      }
    },
    closedd: function(){
      this.ddOpen = false;
    },
    updateFilter: function(filter){
      var newFilter = filter;
      // Handling dynamic phonecode class groups
      if (Array.isArray(filter)){
        newFilter = filter[0]+' & New';
        this.$store.commit({
          type: 'setSelectedPhonecodeGroup',
          selectedPhonecodeGroup: filter[1]
        });
      } else {
        this.$store.commit({
          type: 'setSelectedPhonecodeGroup',
          selectedPhonecodeGroup: undefined
        });
      }

      this.$store.commit({
        type: 'setSelectedFilter',
        selectedFilter: newFilter
      })

      this.loadMoreStart = '';
      this.loadConversations();
    }
  }
}
</script>

